// web/src/utils/formatters/formatDate.ts
import moment from 'moment';

/**
 * Formats a date string to MM/DD/YYYY format
 * @param dateString The date string to format
 * @returns Formatted date string in MM/DD/YYYY format
 */
const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export default formatDate;

export const formatDateLong = (dateString: string): string => {
  return moment(dateString).format('MMM DD, YY');
};
